import { render, staticRenderFns } from "./OwnDbManage.vue?vue&type=template&id=68849beb&scoped=true&"
import script from "./OwnDbManage.vue?vue&type=script&lang=ts&"
export * from "./OwnDbManage.vue?vue&type=script&lang=ts&"
import style0 from "./OwnDbManage.vue?vue&type=style&index=0&id=68849beb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68849beb",
  null
  
)

export default component.exports